import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Button, Pagination, Row, Spin } from "antd";
import moment from "moment";

import { Viewer } from "@toast-ui/react-editor";
import Swal from "sweetalert2";

import longlifeApi from "../../../apis/Longlife.api";
import { setLoading } from "../../../redux/store/common/commonDuck";
import ApiService from "../../../utils/ApiService";
import CommunityLonglifeImage from "../../channel/community/CommunityLonglifeImage";
import CommunityLonglifeModal from "../../channel/community/CommunityLonglifeModal";

const api = new ApiService();

const EditCommunityLonglifeListComponent = ({
	mediaResult,
	selectCommunity,
	setSelectCommunity,
	setCommunityWriteShow,
	showCategory,
}) => {
	const user = useSelector((state) => state.auth.user);
	const history = useHistory();
	const dispatch = useDispatch();
	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	const obsRef = useRef(null); //observer Element
	const preventRef = useRef(true); //옵저버 중복 실행 방지
	const endRef = useRef(false); //모든 글 로드 확인
	// const [page, setPage] = useState(3); //현재 페이지

	const [pageSize, setPageSize] = useState(5);
	const [currentPageNumber, setCurrentPageNumber] = useState(1);

	const [symptomList, setSymptomList] = useState([]); // 증상 목록
	const [contentList, setContentList] = useState([]);
	const [totalCount, setTotalCount] = useState(0);
	const [modalShow, setModalShow] = useState(false);

	/**
	 * page 넘김
	 */
	const handleChangePagination = async (pageNumber) => {
		const currOffset = (pageNumber - 1) * pageSize;
		setCurrentPageNumber(pageNumber);
	};

	const listRef = useRef();

	useEffect(() => {
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
		getNutrientSearchOption();
		// const observer = new IntersectionObserver(obsHandler, {threshold: 0.5});
		// if (obsRef.current) observer.observe(obsRef.current);
		// return () => {
		//     observer.disconnect();
		// }
	}, []);

	useEffect(() => {
		getContent();
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	}, [showCategory, currentPageNumber]);

	// const obsHandler = ((entries) => { //옵저버 콜백함수
	//     const target = entries[0];
	//     if (!endRef.current && target.isIntersecting && preventRef.current) { //옵저버 중복 실행 방지
	//         preventRef.current = false; //옵저버 중복 실행 방지
	//         setPage(prev => prev + 3); //페이지 값 증가
	//     }
	// })

	// useEffect(() => {
	//     if (user?.id) {
	//         if (totalCount === 0) {
	//             getCommunity()
	//         } else {
	//             if (totalCount >= pageSize) {
	//                 getCommunity()
	//             }
	//         }
	//     }
	// }, [user, pageSize])

	// const getCommunity = useCallback(async () => {
	//     setIsLoading(true);
	//     let param = {
	//         influencerId: (user?.role === "level_1" || user?.role === "super_admin") ? user?.id : user?.partners_id,
	//         offset: 0,
	//         pageSize: pageSize
	//     }
	//     const res = await partnersApi.readCommunityList(param);
	//     if (res.code === 200) {
	//         setTotalCount(res.result.totalCnt);
	//         setCommunityList(res.result?.communityDTOList);
	//         preventRef.current = true;
	//     }
	//     setIsLoading(false);
	// }, [pageSize])

	const getNutrientSearchOption = async () => {
		setIsLoading(true);
		try {
			const param = {
				nutrients_id: "",
			};
			const res = await api.searchNutrientList(param);
			if (res.data.code === 200) {
				setSymptomList(res.data.result.nutrientEffectList);
			} else {
				throw `효능 정보를 가져오기 못했습니다. 다시 시도해주시길 바랍니다.`;
			}
			setIsLoading(false);
		} catch (error) {
			setIsLoading(false);
			console.log("getNutrientSearchOption read error", error);
			alert(error);
		}
	};

	const getContent = async (type = "") => {
		setIsLoading(true);
		// let param = {
		// 	offset: (currentPageNumber - 1) * pageSize,
		// 	pageSize: pageSize,
		// 	contentType: "total",
		// 	influencerId:
		// 		user?.role === "level_1" || user?.role === "super_admin"
		// 			? user?.id
		// 			: user?.partners_id,
		// 	categoryId: 0,
		// 	userId: user?.id,
		// };
		// const res = await longlifeApi.getContentList(param);
		let param;
		if (!!type && type === "initial") {
			param = {
				offset: 0,
				pageSize: pageSize,
				partnersId:
					user?.role === "level_1" || user?.role === "super_admin"
						? user?.id
						: user?.partners_id,
				category: showCategory.value ?? "all",
				orderType: "created_at",
				orderBy: "desc",
			};
		} else {
			param = {
				offset: (currentPageNumber - 1) * pageSize,
				pageSize: pageSize,
				partnersId:
					user?.role === "level_1" || user?.role === "super_admin"
						? user?.id
						: user?.partners_id,
				category: showCategory.value,
				orderType: "created_at",
				orderBy: "desc",
			};
		}
		const res = await api.readContentListForTogetherAdmin(param);
		if (res.data.code === 200) {
			for (const communityEl of res.data.result.contentDTOList) {
				let newContent = communityEl.content
					.replaceAll("<p>", `<span>`)
					.replaceAll("</p>", `</span><br>`)
					.replaceAll(
						"<h1>",
						`<strong style="font-size: 18px; color: #495057; line-height: 25px;">`
					)
					.replaceAll("</h1>", `</strong><br>`)
					.replaceAll("<a>", `<span>`)
					.replaceAll("</a>", `</span>`)
					.replaceAll("href", `id`)
					// .replaceAll("<strong>", ``)
					// .replaceAll("</strong>", ``)
					.replaceAll("<span></span>", ``)
					.replaceAll(
						`<span>`,
						`<span style="font-size: 18px; color: #495057; line-height: 25px;">`
					)
					// .replaceAll(`<img`, `<span`)
					// .replaceAll(
					// 	/<img src=(")([\\w{}/?.,;:|)*~!^\\-_+<>@#$%&\\\\=(]+)\\1 contenteditable="false" style="width: 100%;">/g,
					// 	""
					// )
					?.split("<br>")
					.slice(0, 4)
					.join("<br>");

				newContent += `<br><span style="font-size: 18px; color: #868e96;">더보기...</span>`;

				communityEl.content = newContent;
			}
			setTotalCount(res.data.result.totalCnt);
			setContentList(res.data.result?.contentDTOList);
			preventRef.current = true;
		} else {
			setTotalCount(0);
			setContentList([]);
		}
		setIsLoading(false);
	};

	const getContentOne = async (item) => {
		setIsLoading(true);
		try {
			let param = {
				id: item?.id,
				// offset: 0,
				// pageSize: 5,
				// pageType: switchCategoryForEng(item?.content_type),
				// missionId: item?.id,
				// userId: user?.id ? user.id : 0,
			};
			// const res = await longlifeApi.getContent(param);
			const res = await api.readContentOneForTogetherAdmin(param);
			if (res.data.code === 200) {
				setIsLoading(false);
				return res.data.result;
			}
		} catch (e) {
			console.log(e);
		}
		setIsLoading(false);
	};

	const handleCommunity = (item) => {
		setSelectCommunity(item);
		setModalShow(true);
	};

	/**
	 * 소통글 수정
	 * @param e
	 * @returns {Promise<void>}
	 */
	const editMagazine = async (e, item) => {
		e.stopPropagation();
		const findInfo = await getContentOne(item);
		setSelectCommunity(findInfo);
		setCommunityWriteShow(true);
	};

	/**
	 * 소통글 삭제
	 * @param e
	 * @returns {Promise<void>}
	 */
	const deleteMagazine = async (e, item) => {
		e.stopPropagation();
		Swal.fire({
			customClass: "alert-custom",
			text: `해당 게시글을 삭제하시겠습니까?`,
			showCancelButton: true,
			confirmButtonText: "확인",
			cancelButtonText: "취소",
		}).then(async (result) => {
			if (result.isConfirmed) {
				setIsLoading(true);
				const param = {
					content_id: item.id,
					user_id:
						user?.role === "level_1" || user?.role === "super_admin"
							? user?.id
							: user?.partners_id,
				};
				const res = await api.deleteContent(param);
				if (res.data.code === 200) {
					Swal.fire({
						customClass: "alert-custom",
						text: "성공적으로 삭제되었습니다!",
						confirmButtonText: "확인",
					}).then(() => {
						setCurrentPageNumber(1);
						getContent("initial");
						setIsLoading(false);
					});
				} else {
					Swal.fire({
						customClass: "alert-custom",
						text: "오류가 발생했습니다. 잠시 후 다시 시도해주세요.",
						confirmButtonText: "확인",
					}).then(() => {
						setIsLoading(false);
					});
				}
				setIsLoading(false);
			}
		});
	};

	const switchCategoryForEng = (categoryId) => {
		switch (categoryId) {
			case 0:
				return "mission";
			case 1:
				return "community";
			case 2:
			case 3:
				return "feed";
			default:
				return "";
		}
	};

	const switchCategory = (categoryId) => {
		switch (categoryId) {
			case "mission":
				return "클래스";
			case "compare":
			case "nutrition_encyclopedia":
			case "age":
			case "symptom":
			case "trend":
			case "selection":
			case "brand":
			case "etc":
				return "건강 매거진";
			case "cooperate":
				return "공동구매";
			case "recommend_nutrients":
				return "문의글";
			case "event":
				return "이벤트";
			// case "compare":
			// 	return "비교하기";
			// case "nutrition_encyclopedia":
			// 	return "영양백과";
			// case "age":
			// 	return "연령별";
			// case "symptom":
			// 	return "증상별";
			// case "trend":
			// 	return "트렌드";
			// case "selection":
			// 	return "선택기준";
			// case "brand":
			// 	return "브랜드";
			// case "etc":
			// 	return "기타";
			// case 0:
			// 	return "미션";
			// case 1:
			// 	return "소통글";
			// case 2:
			// 	return "피드";
			// case 3:
			// 	return "상세피드";
			default:
				return "";
		}
	};

	const switchAgeCategory = (subCategory) => {
		switch (subCategory) {
			case 0:
			case "0":
				return "0~2세";
			case 1:
			case "1":
				return "2~13세";
			case 2:
			case "2":
				return "0~13세";
			case 3:
			case "3":
				return "청소년";
			case 4:
			case "4":
				return "청소년부터 성인까지";
			case 5:
			case "5":
				return "성인";
			case 6:
			case "6":
				return "전 연령";
			case 9:
			case "9":
				return "50세 이상";
			case 99:
			case "99":
				return "기타";
		}
	};

	const switchSymptomCategory = (subCategory) => {
		const findIdx = symptomList.findIndex(
			(symptom) => symptom.effect_id === subCategory
		);
		if (findIdx > -1) {
			return symptomList[findIdx].effect_name;
		} else {
			return "";
		}
	};

	return (
		<>
			{isLoading && (
				<Spin
					style={{
						margin: "auto",
						width: "100%",
						paddingTop: "2em",
						position: "absolute",
						left: 0,
						right: 0,
					}}
				/>
			)}
			{contentList?.length ? (
				<>
					{contentList?.map((item, idx) => (
						<div
							key={`community-${idx}`}
							className={`home-community-each modal-community community-each-page community-list-content`}
							onClick={() => handleCommunity(item)}
							ref={listRef}
						>
							{/*{!!item?.is_reservation && (*/}
							{/*	<Button*/}
							{/*		style={{*/}
							{/*			position: "absolute",*/}
							{/*			right: "2em",*/}
							{/*			top: "2em",*/}
							{/*			display: "flex",*/}
							{/*			alignItems: "center",*/}
							{/*			gap: "5px",*/}
							{/*		}}*/}
							{/*	>*/}
							{/*		<img*/}
							{/*			src={`/assets/images/channel/timer.png`}*/}
							{/*			alt={`공동구매`}*/}
							{/*			className={`group-buying-alert-icon`}*/}
							{/*			style={{*/}
							{/*				height: "auto",*/}
							{/*				width: "1.2em",*/}
							{/*			}}*/}
							{/*		/>*/}
							{/*		<p*/}
							{/*			style={{*/}
							{/*				color: "#adb5bd",*/}
							{/*			}}*/}
							{/*		>*/}
							{/*			예약됨{" "}*/}
							{/*			{moment(item?.post_from).format("YYYY.MM.DD a h:mm 예정")}*/}
							{/*		</p>*/}
							{/*	</Button>*/}
							{/*)}*/}
							<div className={`home-community-content`}>
								<div className={`community-title-div`}>
									<div style={{ display: "flex" }}>
										<p
											className={`community-tag`}
											style={{
												backgroundColor: `${
													item?.background_color
														? item.background_color
														: "#868e96"
												}`,
											}}
										>
											{switchCategory(item?.category)}
											{/*{item?.category &&*/}
											{/*	item?.sub_category &&*/}
											{/*	(item?.category === "age"*/}
											{/*		? `-${switchAgeCategory(item?.sub_category)}`*/}
											{/*		: `-${switchSymptomCategory(item?.sub_category)}`)}*/}
											{/*{switchCategory(item?.content_type) &&*/}
											{/*	`[${switchCategory(item?.content_type)}]-`}*/}
											{/*{item?.category_name}*/}
										</p>
										{item?.is_reservation &&
											moment(item?.reservation_date) > moment() && (
												<p
													className={`community-tag`}
													style={{
														backgroundColor: "#fe2b4b",
														marginLeft: "0.5rem",
														paddingRight: "1rem",
														paddingLeft: "1rem",
													}}
												>
													예약
												</p>
											)}
									</div>
									<p className={`community-title`}>{item?.head_copy}</p>
									<p className={`community-sub-title`}>{item?.sub_copy}</p>
									{/*{item?.content_type === 0 && (*/}
									{/*	<p className={`community-sub-title`}>{item?.sub_title}</p>*/}
									{/*)}*/}
								</div>
								<div className={`community-footer-div mobile-noShow`}>
									{item?.category !== "mission" && (
										<>
											<p>좋아요 {item?.favorite_cnt ?? 0}</p>
											<p>·</p>
											<p>댓글 {item?.comment_num ?? 0}</p>
											<p>·</p>
											<p>조회수 {item?.clicked ?? 0}</p>
											<p>·</p>
										</>
									)}
									<p>{moment(item?.created_at).format("YYYY.MM.DD")}</p>
								</div>
								{/*<div className={`community-body-div`}>*/}
								{/*	/!*{!!item.content?.includes("<p>") ? }*!/*/}
								{/*	<p>{item?.body?.replace("\n", "")}</p>*/}
								{/*</div>*/}
							</div>
							{!!item?.main_img_type && (
								<div
									className={`mobile-community-image`}
									style={{ width: "100%" }}
								>
									<img
										src={
											item?.category === "mission"
												? `${process.env.REACT_APP_S3_LONGLIFE_HOST}/images/mission/thumbnail/${item?.id}.${item?.main_img_type}`
												: `${process.env.REACT_APP_S3_HOST}/image/contentMain/${item?.id}.${item?.main_img_type}`
										}
										onError={({ currentTarget }) => {
											currentTarget.onerror = null; // prevents looping
											// currentTarget.style.display = "none";
											currentTarget.src = `/assets/images/no-product.png`;
										}}
										alt={`게시판 이미지`}
										style={{
											height: "100%",
											width: "100%",
										}}
									/>
								</div>
							)}
							{/*{!!(!!item?.imageList?.length && user?.id) && (*/}
							{/*	<>*/}
							{/*		<CommunityLonglifeImage*/}
							{/*			item={item}*/}
							{/*			imageList={[item?.imageList[0]]}*/}
							{/*		/>*/}
							{/*	</>*/}
							{/*)}*/}
							<Viewer
								key={`longlife-content-${item?.id}`}
								initialValue={item?.content}
							/>
							{/*{item?.category === "cooperate" && (*/}
							{/*	<CooperatePreview item={item} />*/}
							{/*)}*/}
							{/*<div className={`community-body-div`}>*/}
							{/*	/!*{!!item.content?.includes("<p>") ? }*!/*/}
							{/*	/!*<p>{item?.body?.replace("\n", "")}</p>*!/*/}
							{/*</div>*/}
							<div className={`community-footer-div mobile-show`}>
								{item?.category !== "mission" && (
									<>
										<p>좋아요 {item?.favorite_cnt ?? 0}</p>
										<p>·</p>
										<p>댓글 {item?.comment_num ?? 0}</p>
										<p>·</p>
									</>
								)}
								<p>조회수 {item?.clicked ?? 0}</p>
								<p>·</p>
								<p>{moment(item?.created_at).format("YYYY.MM.DD")}</p>
							</div>
							{item?.category !== "mission" &&
								item?.influencer_id === user?.id && (
									<Row className={`community-edit-button-group`}>
										<Button onClick={(e) => editMagazine(e, item)}>수정</Button>
										<Button onClick={(e) => deleteMagazine(e, item)}>
											삭제
										</Button>
									</Row>
								)}
						</div>
					))}
				</>
			) : (
				<Row
					align={"middle"}
					style={{ width: "100%", flexDirection: "column", padding: "3em 0" }}
				>
					<img
						src={`/assets/images/warning.png`}
						alt={`warning-icon`}
						style={{
							width: "3.5em",
							height: "auto",
						}}
					/>
					<span
						style={{
							marginTop: "1em",
							color: "#adb5bd",
							fontSize: "1.2em",
							fontWeight: 500,
						}}
					>
						일치하는 내용이 없습니다.
					</span>
				</Row>
			)}
			{/*/!* 건별 콘텐츠 보기 *!/*/}
			{/*{modalShow && (*/}
			{/*    <CommunityModal*/}
			{/*        modalShow={modalShow}*/}
			{/*        setModalShow={setModalShow}*/}
			{/*        detail={selectCommunity}*/}
			{/*        whereShow={'edit'}*/}
			{/*        // getCommunityList={getCommunityList}*/}
			{/*    />*/}
			{/*)}*/}
			<div ref={obsRef} />
			<Pagination
				className="report-pagination-wrap"
				style={{
					margin: "auto",
				}}
				showSizeChanger={false}
				current={currentPageNumber}
				pageSize={pageSize}
				total={totalCount}
				onChange={handleChangePagination}
			/>

			{/*글 단건 조회*/}
			{modalShow && (
				<CommunityLonglifeModal
					modalShow={modalShow}
					setModalShow={setModalShow}
					setSelectCommunity={setSelectCommunity}
					detail={selectCommunity}
					symptomList={symptomList}
				/>
			)}
		</>
	);
};

const CooperatePreview = ({ item }) => {
	return (
		<div
			style={{
				border: "solid 1px #ced4da",
				borderRadius: 5,
				padding: "1em",
				display: "flex",
				gap: "2em",
			}}
		>
			<img
				src={
					item?.cooperateInfo?.product_id
						? `${process.env.REACT_APP_CDN}/image/recommend/${item?.cooperateInfo?.target_id}.jpg`
						: `${process.env.REACT_APP_CDN}/image/together/group_buying/${item?.cooperateInfo?.target_id}.jpg`
				}
				onError={({ currentTarget }) => {
					currentTarget.onerror = null; // prevents looping
					// currentTarget.style.display = "none";
					currentTarget.src = `/assets/images/no-product.png`;
				}}
				alt={`${item?.cooperateInfo?.product_brand_name} ${item?.cooperateInfo?.product_name}`}
				style={{
					width: 120,
					height: 120,
					objectFit: "contain",
				}}
			/>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
				}}
			>
				<p
					style={{
						margin: 0,
						fontSize: "1em",
						fontWeight: 500,
						letterSpacing: -0.8,
						color: "#868e96",
					}}
				>
					{moment(item?.cooperateInfo?.cooperate_start_date)?.format(
						"YYYY.MM.DD HH:mm"
					)}{" "}
					~{" "}
					{moment(item?.cooperateInfo?.cooperate_end_date)?.format(
						"YYYY.MM.DD HH:mm"
					)}
				</p>
				<p
					style={{
						fontWeight: "bold",
						fontSize: "1.3em",
						marginBottom: "0.5em",
					}}
				>
					{item?.cooperateInfo?.product_brand_name} >{" "}
					{item?.cooperateInfo?.product_name}
				</p>
				<p style={{ margin: 0, fontWeight: 500, fontSize: "1em" }}>
					- {item?.cooperateInfo?.usp}
				</p>
				<p style={{ margin: 0, fontSize: "1em" }}>
					- {item?.cooperateInfo?.information_1}
				</p>
				<p style={{ margin: 0, fontSize: "1em" }}>
					- {item?.cooperateInfo?.information_2}
				</p>
				<p style={{ margin: 0, fontSize: "1em" }}>
					- {item?.cooperateInfo?.information_3}
				</p>
			</div>
		</div>
	);
};
export default EditCommunityLonglifeListComponent;
